import { types, actions } from './requests'
export const GETTASKLIST_TYPES = {
    ...types('GETTASKLIST'),
}
export const GETTASKLIST_ACTIONS = {
    ...actions('GETTASKLIST'),
}